import axios from "axios";
import {
  GET_NIC_NETWORK_API,
  GET_NIC_NETWORK_ADAPTER_TYP_API,
  GET_OSTYPES_API,
  GET_OSVERSIONS_API,
  GET_VAPP_TEMPLATES,
  GET_VM_DETAILS_API,
  GET_NIC_IP_MODES_API,
  GET_VAPP_TEMPLATES_VM_DETAILS_API,
  CREATE_COURSE_DEFINITION,
  UPDATE_COURSE_DEFINITION,
  PUBLISH_COURSE_DEFINITION,
  VIEW_COURSE_DEFINITION_API,
} from "../../../../../common/apiEndPoint/apiEndPoint";
import { config } from "../../../../../common/authentication/config";
import AuthProvider from "../../../../../common/authentication/authService";

const SITE_ID = config.SITE_ID;
export const cookieVal = () => {
  const cookie = AuthProvider()?.getCookie("XSRF-TOKEN");
  // const cookie = localStorage['XSRF-TOKEN'];
  if (cookie !== "") {
    return cookie;
  }
};
/**
 * Function to get vApp templates from the API
 * @param requestParams - Authorization parameters
 * @returns Promise with API response
 */

export const getvAppTemplatesAPI = async (requestParams: any) => {
  try {
    const res: any = await axios.get(`${GET_VAPP_TEMPLATES}`, {
      headers: {
        Authorization: `Bearer ${requestParams?.authorization}`,
        siteId: SITE_ID,
        "X-XSRF-TOKEN": cookieVal(),
      },
    });
    return res;
  } catch (error) {}
};

export const getOSListApi = async (requestParams: any) => {
  try {
    const res: any = await axios.get(`${GET_OSTYPES_API}`, {
      headers: {
        Authorization: `Bearer ${requestParams?.authorization}`,
        siteId: SITE_ID,
        "X-XSRF-TOKEN": cookieVal(),
      },
    });
    return res;
  } catch (error) {}
};
export const getOSVersionsApi = async (requestParams: any) => {
  try {
    const res: any = await axios.get(
      `${GET_OSVERSIONS_API}/${requestParams?.osId}`,
      {
        headers: {
          Authorization: `Bearer ${requestParams?.authorization}`,
          siteId: SITE_ID,
          "X-XSRF-TOKEN": cookieVal(),
        },
      }
    );
    return res;
  } catch (error) {}
};
export const getNicNetworkApi = async (requestParams: any) => {
  try {
    const res: any = await axios.get(`${GET_NIC_NETWORK_API}`, {
      headers: {
        Authorization: `Bearer ${requestParams?.authorization}`,
        siteId: SITE_ID,
        "X-XSRF-TOKEN": cookieVal(),
      },
    });
    return res;
  } catch (error) {}
};
export const getNicNetworkAdapterTypeApi = async (requestParams: any) => {
  try {
    const res: any = await axios.get(`${GET_NIC_NETWORK_ADAPTER_TYP_API}`, {
      headers: {
        Authorization: `Bearer ${requestParams?.authorization}`,
        siteId: SITE_ID,
        "X-XSRF-TOKEN": cookieVal(),
      },
    });
    return res;
  } catch (error) {}
};
export const getNicIpModesApi = async (requestParams: any) => {
  try {
    const res: any = await axios.get(`${GET_NIC_IP_MODES_API}`, {
      headers: {
        Authorization: `Bearer ${requestParams?.authorization}`,
        siteId: SITE_ID,
        "X-XSRF-TOKEN": cookieVal(),
      },
    });
    return res;
  } catch (error) {}
};
export const getVmDetailsAPI = async (requestParams: any) => {
  try {
    const res: any = await axios.get(
      `${GET_VM_DETAILS_API}/${requestParams?.vAppTemplateId}?pageNo=${requestParams?.pageNo}&pageSize=${requestParams?.pageSize}`,
      {
        headers: {
          Authorization: `Bearer ${requestParams?.authorization}`,
          siteId: SITE_ID,
          "X-XSRF-TOKEN": cookieVal(),
        },
      }
    );
    return res;
  } catch (error) {}
};
export const getVappTemplatesAndVmDetailsAPI = async (requestParams: any) => {
  try {
    const res: any = await axios.get(
      `${GET_VAPP_TEMPLATES_VM_DETAILS_API}?pageNo=${requestParams?.pageNo}&pageSize=${requestParams?.pageSize}`,
      {
        headers: {
          Authorization: `Bearer ${requestParams?.authorization}`,
          siteId: SITE_ID,
          "X-XSRF-TOKEN": cookieVal(),
        },
      }
    );
    return res;
  } catch (error) {}
};
export const saveCourseDefinitionAPI = async (requestParams: any) => {
  try {
    const res: any = await axios.post(
      `${CREATE_COURSE_DEFINITION}`,
      requestParams.payload,
      {
        headers: {
          Accept: "application/json;version=36.3",
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          siteId: SITE_ID,
          "X-XSRF-TOKEN": cookieVal(),
        },
      }
    );
    return res;
  } catch (error) {
    throw error;
  }
};
export const updateCourseDefinitionAPI = async (requestParams: any) => {
  try {
    const res: any = await axios.put(
      `${UPDATE_COURSE_DEFINITION}`,
      requestParams.payload,
      {
        headers: {
          Accept: "application/json;version=36.3",
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          siteId: SITE_ID,
          "X-XSRF-TOKEN": cookieVal(),
        },
      }
    );
    return res;
  } catch (error) {}
};
export const publishCourseDefinitionAPI = async (requestParams: any) => {
  try {
    const res: any = await axios.post(
      `${PUBLISH_COURSE_DEFINITION}`,
      requestParams.payload,
      {
        headers: {
          Accept: "application/json;version=36.3",
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          siteId: SITE_ID,
          "X-XSRF-TOKEN": cookieVal(),
        },
      }
    );
    return res;
  } catch (error) {
    throw error;
  }
};
export const getCourseDataByIdAPI = async (requestParams: any) => {
  try {
    const res: any = await axios.get(
      `${VIEW_COURSE_DEFINITION_API}/${requestParams?.courseId}`,
      {
        headers: {
          Authorization: `Bearer ${requestParams?.authorization}`,
          siteId: SITE_ID,
          "X-XSRF-TOKEN": cookieVal(),
        },
      }
    );
    return res;
  } catch (error) {}
};
